import { LocationCountryCode } from 'src/api/generated';
import {
  type ClientTypeOverrides,
  type CountryClientTypeOverrides,
} from '../../types/i18n/i18n.type';
import { realEstateEsClOverrides } from './real-estate/es-CL';
import { realEstateEsClCoOverrides } from './real-estate/es-CL-CO';
import { realEstateEnUsOverrides } from './real-estate/en-US';

/**
 * All client type overrides organized by language and client type
 */
export const clientTypeOverrides: ClientTypeOverrides = {
  'es-CL': {
    GENERAL: {},
    REAL_ESTATE: realEstateEsClOverrides,
  },
  'en-US': {
    GENERAL: {},
    REAL_ESTATE: realEstateEnUsOverrides,
  },
};

/**
 * Country-specific client type overrides organized by language, client type and tenant country.
 */
export const clientTypeCountryOverrides: CountryClientTypeOverrides = {
  'es-CL': {
    REAL_ESTATE: {
      [LocationCountryCode.CO]: realEstateEsClCoOverrides,
    },
  },
  'en-US': {},
};
